var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('praeco-form-item',{attrs:{"label":"Bot Id","prop":"larkBotId","required":""}},[_c('el-input',{attrs:{"id":"larkBotId","value":_vm.larkBotId,"disabled":_vm.viewOnly},on:{"input":function($event){_vm.larkBotId = $event}}}),_c('label',[_vm._v("Lark bot id.")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }